<template>
  <!-- Start Hero -->
  <section class="relative table w-full py-8 bg-[url('../../assets/images/company/aboutus.jpg')] bg-center bg-no-repeat">
    <div class="absolute inset-0 bg-black opacity-75"></div>
    <div class="container">
      <div class="grid grid-cols-1 pb-8 text-center mt-10">
        <h3 class="md:text-4xl text-3xl md:leading-normal tracking-wide leading-normal font-medium text-white">Contact</h3>
      </div>
    </div>

    <div class="absolute text-center z-10 bottom-5 right-0 left-0 mx-3">
      <ul class="breadcrumb tracking-[0.5px] breadcrumb-light mb-0 inline-block">
        <li
          class="inline breadcrumb-item uppercase text-[13px] font-bold duration-500 ease-in-out text-white/50 hover:text-white">
          <a href="index.html">BSD</a></li>
        <li class="inline breadcrumb-item uppercase text-[13px] font-bold duration-500 ease-in-out text-white"
          aria-current="page">Contactez-nous</li>
      </ul>
    </div>
  </section>
  <div class="relative">
    <div
      class="shape absolute right-0 sm:-bottom-px -bottom-[2px] left-0 overflow-hidden z-1 text-white dark:text-slate-900">
      <svg class="w-full h-auto" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
      </svg>
    </div>
  </div>
  <!-- End Hero -->
</template>

<script>
export default {

}
</script>

<style></style>